import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../Button';
import { componentsTranslations } from '../../../translations';

const LoadMorePagination = ({
    onLoadMore,
    children,
    currentCount,
    showButton,
    totalCount,
    isButtonDisabled,
    showLabel,
    ...others
}) => {
    const buttonBorderClassName = `border-${isButtonDisabled ? 'secondary' : 'primary'}`;

    return (
        <div className="d-flex justify-content-center">
            <div className="load-more__section">
                {showLabel && (
                    <div className="load-more__count font-italic">
                        <FormattedMessage
                            {...componentsTranslations.ng_components_paginationCount}
                            values={{ currentCount, totalCount }}
                        />
                    </div>
                )}
                {showButton && (
                    <Button
                        onClick={onLoadMore}
                        color="primary"
                        variant="outline"
                        className={`${buttonBorderClassName} load-more__button`}
                        disabled={isButtonDisabled}
                        {...others}
                    >
                        {children}
                    </Button>
                )}
            </div>
        </div>
    );
};

LoadMorePagination.displayName = 'LoadMorePagination';

LoadMorePagination.propTypes = {
    children: PropTypes.node,
    currentCount: PropTypes.number,
    isButtonDisabled: PropTypes.bool,
    onLoadMore: PropTypes.func,
    showButton: PropTypes.bool,
    showLabel: PropTypes.bool,
    totalCount: PropTypes.number
};

export default LoadMorePagination;
